import { useMemo } from "react";

interface IconCheckboxProps {
  active?: boolean;
}
export const IconCheckbox = ({ active }: IconCheckboxProps) => {
  const bg = useMemo(() => (active ? "#FD9340" : "#fff"), [active]);
  const bd = useMemo(() => (active ? "#FD9340" : "#ccc"), [active]);
  const color = useMemo(() => (active ? "#fff" : "#ccc"), [active]);
  return (
    <svg
      className="min-w-6 min-h-6"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="transition-colors"
        d="M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z"
        fill={bg}
        stroke={bd}
      />
      <path
        className="transition-colors"
        d="M7.70725 12.2921C7.31625 11.9011 6.68425 11.9011 6.29325 12.2921C5.90225 12.6831 5.90225 13.3151 6.29325 13.7061L9.29325 16.7061C9.48125 16.8941 9.73525 16.9991 10.0002 16.9991C10.0113 16.9991 10.0222 16.9991 10.0332 16.9991C10.3102 16.9891 10.5703 16.8661 10.7523 16.6581L17.7522 8.65814C18.1163 8.24214 18.0743 7.61014 17.6593 7.24714C17.2432 6.88314 16.6123 6.92714 16.2483 7.34014L9.95125 14.5361L7.70725 12.2921Z"
        fill={color}
      />
    </svg>
  );
};
